import { Injectable } from '@angular/core';
import { SessionAwareMultiStore } from '../../../../shared/stores/session-aware-store';
import { CreditPlan } from '../models/credit-plan';

@Injectable({ providedIn: 'root' })
export class CreditPlansStore extends SessionAwareMultiStore<CreditPlan> {}
